import { Button, LoadingSpinner } from '@idexx-laboratories/spot-react';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '../../components/Grid/Grid';
import { useStore } from '../../hooks/use-store';
import './RoleManagement.scss';

const RoleManagement = observer(() => {
  const { roleManagementStore: store } = useStore();
  const { resourcePermissionsFiltered, sorting, loaders, edited, roleName } = store;
  const navigate = useNavigate();

  useEffect(() => {
    void store.init();
    return () => {
      store.close();
    };
  }, [store]);

  if (loaders.page) return <LoadingSpinner size='large' />;

  return (
    <div className='role-management-wrapper'>
      <div className='spot-typography__heading--level-2'>Role</div>
      <div className='spot-card--primary role-management-card'>
        <div className='spot-card--body demo-card-height'>
          <div className='spot-typography__text--body role-name'>
            {roleName} {loaders.role && <LoadingSpinner />}
          </div>
        </div>
      </div>
      <div className='role-management-table'>
        <Grid
          id='role-management-grid'
          columns={store.colDefs}
          data={resourcePermissionsFiltered}
          sorting={sorting}
          noRowsText='No data'
          rowIdField='resourceId'
        />
      </div>
      <div className='page-bottom-actions'>
        <Button className='back' variant='link' size='small' onClick={() => navigate(-1)}>
          Back
        </Button>
        <div className='main-buttons'>
          <Button
            variant='primary'
            size='small'
            disabled={!edited || loaders.role}
            onClick={() => void store.updateRole()}
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  );
});

export default RoleManagement;
